export default __webpack_public_path__ + "static/media/soldier-intro.22decc49.mp3";